<div class="add-competitor-dialog">
  <div class="dialog-header">
    <h3>Add Competitor</h3>
    <button type="button" class="close-btn" (click)="onClose()" aria-label="Close">&times;</button>
  </div>

  <div class="dialog-body">
    <p class="dialog-note">Add one competitor and run Re-Analysis to refresh overview and related tabs.</p>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Competitor Name</mat-label>
        <input
          matInput
          id="competitor-name"
          type="text"
          [(ngModel)]="competitorName"
          [disabled]="processing"
          placeholder="Enter competitor name" />
        <mat-error *ngIf="isPrimaryBrandNameConflict">
          Primary brand cannot be added as competitor.
        </mat-error>
        <mat-error *ngIf="!isPrimaryBrandNameConflict && isExistingCompetitorNameConflict">
          This competitor already exists in this project.
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Competitor URL</mat-label>
        <input
          matInput
          id="competitor-url"
          type="text"
          [(ngModel)]="competitorUrl"
          [disabled]="processing"
          placeholder="www.competitor.com" />
        <mat-error *ngIf="isPrimaryBrandDomainConflict">
          Primary brand domain cannot be added as competitor.
        </mat-error>
        <mat-error *ngIf="!isPrimaryBrandDomainConflict && isExistingCompetitorDomainConflict">
          This competitor URL/domain already exists in this project.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="dialog-actions">
      <button type="button" class="btn btn-secondary" (click)="onClose()" [disabled]="processing">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="onReAnalysis()" [disabled]="!canSubmit || processing">
        {{ processing ? 'Processing...' : 'Re-Analysis' }}
      </button>
    </div>
  </div>
</div>
